import moment from "moment"

export function cleanJobsData(jobs, filterBy) {


    return jobs.filter(job => {
        switch(filterBy) {
            case 'active':
                return job.isActive
            case 'inactive':
                return !job.isActive
            default:
                return true
        }
    }).map(job => {
        return {
            ...job,
            address: `${job.street1 ? job.street1 : ""} ${job.street2 ? job.street2 : ""} ${job.city ? `${job.city}, ` : ""} ${job.state ? job.state : ""} ${job.zipcode ? job.zipcode : ""}`,
            estimatedStartDate: moment(job.estimatedStartDate).isValid() ? moment(job.estimatedStartDate).format("MM/DD/YYYY") : ""
        }
    })
}